// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesExam = {
  examAttempt: "exam attempt",
  examExam: "exam",
  examPaper: "exam paper",
  examPaperItem: "exam paper item",
  examPaperVersion: "exam paper version",
  examPlatform: "exam platform",
  examReview: "exam review",
  examUser: "exam user",
  examAuth: "exam authentication",
  examScoring: "exam scoring",
  examSystem: "exam system",
  examExecutionFabric: "exam Execution Fabric",
  examTaskCenter: "exam task center",
} as const;
